import { render, staticRenderFns } from "./ProviderFaresPanel.vue?vue&type=template&id=6744158c&scoped=true"
import script from "./ProviderFaresPanel.vue?vue&type=script&lang=js"
export * from "./ProviderFaresPanel.vue?vue&type=script&lang=js"
import style0 from "./ProviderFaresPanel.vue?vue&type=style&index=0&id=6744158c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6744158c",
  null
  
)

export default component.exports